import {
  ConfigurationRuleScopeEntityType,
  ConfigurationRuleScopeMode,
  ConfigurationRuleSetupType,
  StoreResponse,
} from '@ydistri/api-sdk';
import { ListType } from '../../../../apis/apiLists';

export type ScopeEntitySetting = Record<ConfigurationRuleScopeEntityType, ScopeEntity>;

export interface ScopeEntity {
  selectionOption: ConfigurationRuleScopeMode;
  selectedIds: number[];
}

export interface ScopeConfiguration {
  [ConfigurationRuleSetupType.UseAsSource]: boolean | null;
  [ConfigurationRuleSetupType.UseAsTarget]: boolean | null;
  [ConfigurationRuleSetupType.IsEnabled]: boolean | null;
  [ConfigurationRuleSetupType.MaxNumberOfSourceStores]: number | null;
  [ConfigurationRuleSetupType.MaxNumberOfTargetStores]: number | null;
  [ConfigurationRuleSetupType.MaxNumberOfSourcePickingPositions]: number | null;
  [ConfigurationRuleSetupType.MinimumRouteValue]: number | null;
}

export interface Scope {
  id: number;
  priority: number;
  name: string | undefined;
  creating: boolean;
  entities: ScopeEntitySetting;
  configuration: ScopeConfiguration;
}

export enum ScopeConfigurationErrorType {
  CORRECT = 'correct',
  ERROR = 'unknownError',
  ALL_CONFIGS_NULL = 'allConfigsNull',
  EMPTY_MULTISELECT = 'emptyMultiselect',
  ALL_SCOPES_SET_TO_ALL = 'allScopesSetToALl',
}

export interface FilterRuleScopeArgs {
  scope: Scope;
  regionIds: number[];
  storeIds: number[];
  storeListObject: ListType<StoreResponse>['object'];
  storeTypeIds: number[];
  departmentIds: number[];
}

export type FilteredEntityIds = Record<ConfigurationRuleScopeEntityType, number[]>;
export type IdMap = Record<number, true | undefined>;

export enum ViewMode {
  GENERAL_CONFIGURATION = 'general-config',
  EXCEPTION = 'exception',
  NEW_EXCEPTION_MODAL = 'new-exception-modal',
  ADJUST_SCOPE_MODAL = 'adjust-scope-modal',
}

export enum ScopeModalType {
  CREATE = 'create',
  EDIT = 'edit',
}
